/*--------------------------------------------------------------------------*
 * SMOOTH SCROLL
 *--------------------------------------------------------------------------*/
/*
 * href: string 遷移先のid
 * animate?: boolean アニメーションするか (初期値: true)
 */
module Module_SmoothScroll {
	export class Model_SmoothScroll {
		run(href: string, animate?: boolean): void {
			animate = animate === false ? false : true;

			const body: JQuery = $("html, body"),
				speed: number = 600,
				target: JQuery = $(href == "#" || href == "" ? "html" : href),
				header_h: number = $(".l-header").height(),
				margin: number = 38,
				position: number = target.offset().top - (header_h + margin);

			body.animate({scrollTop:position}, speed, "swing")
		}
	}
}
